import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FacialIDVerification from './index';

export const FacialVerificationDialog = ({
    open,
    onClose,
    task_id,
    patient,
    workflowType,
    verificationStatus,
    imageUrl,
    getFacialRecognitionPresignedUrl,
    restartVerification,
    onProceed
}) => {
    return (
        <Dialog
            open={open}
            aria-labelledby="form-dialog-title"
            maxWidth="xl"
            fullWidth={true}
        >
            <DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <FacialIDVerification
                    task_id={task_id}
                    patient={patient}
                    workflowType={workflowType}
                    verificationStatus={verificationStatus}
                    getFacialRecognitionPresignedUrl={getFacialRecognitionPresignedUrl}
                    restartVerification={restartVerification}
                    onProceed={onProceed}
                    imageUrl={imageUrl}
                />
            </DialogContent>
        </Dialog>
    );
};
